import { render, staticRenderFns } from "./edittxForm.vue?vue&type=template&id=3279cedc&scoped=true&"
import script from "./edittxForm.vue?vue&type=script&lang=js&"
export * from "./edittxForm.vue?vue&type=script&lang=js&"
import style0 from "./edittxForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./edittxForm.vue?vue&type=style&index=1&id=3279cedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3279cedc",
  null
  
)

component.options.__file = "edittxForm.vue"
export default component.exports